import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "@curves/ui-base";
import { useLocation, matchPath } from "react-router-dom";
import { isEqual } from "@util/utils";

const NavigationTabs = ({ tabs }) => {
	const { pathname } = useLocation();
	const [indexState, setIndexState] = useState(null);

	if (isEqual(process.env.NODE_ENV, "development")) {
		const valueSet = new Set();
		tabs.forEach(({ value }) => {
			if (valueSet.has(value)) {
				console.warn(`Tabs 傳入重複的 value：${value}`);
			}
			valueSet.add(value);
		});
	}

	const handleTabChange = (_e, newValue) => {
		setIndexState(newValue);
	};

	useEffect(
		() => {
			for (const { value, to } of tabs) {
				const match = matchPath(to, pathname);
				if (match) setIndexState(value);
			}
		},
		// eslint-disable-next-line
		[]
	);

	const TabsMemo = useMemo(
		() => {
			if (!tabs || tabs.length === 0) return null;
			return tabs.map(({ label, value, icon: IconComponent = null, component: Component, to }) => {
				return (
					<Tab
						key={value}
						className={"py-3"}
						label={
							<>
								{IconComponent && React.createElement(IconComponent, { className: "mr-2" })}
								{label}
							</>
						}
						value={value}
						component={Component}
						to={to}
					/>
				);
			});
		},
		// eslint-disable-next-line
		[tabs]
	);

	return (
		<Tabs value={indexState} onChange={handleTabChange}>
			{TabsMemo}
		</Tabs>
	);
};

NavigationTabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			label: PropTypes.string.isRequired,
			icon: PropTypes.elementType,
			component: PropTypes.elementType,
			to: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default NavigationTabs;
